import React from 'react';
import { useTheme } from '../ThemeContext';
import { useCheckout } from '../CheckoutContext';
import { useT } from '../i18n/useT';
import { useLang } from '../i18n/LanguageContext';

const TwoPathsSection = () => {
  const { isDark } = useTheme();
  const { startCheckout } = useCheckout();
  const t = useT();
  const { isFr } = useLang();
  const tc = isDark ? '#FFFFFF' : '#1B2A4A';

  return (
    <section className="relative mt-20 px-[30px] lg:px-0" id="information">
      <div className="mx-auto max-w-[1140px]">
        <h3 className="text-center text-[13px] tracking-[0.35em] font-medium uppercase transition-colors duration-300" style={{ fontFamily: '"Inter", sans-serif', color: isDark ? '#E6EBF2' : tc }}>{t.twoPaths.label}</h3>
        <h2 className="text-center text-[32px] lg:text-[48px] font-bold mt-1 transition-colors duration-300" style={{ fontFamily: '"Space Grotesk", sans-serif', color: tc }}>{t.twoPaths.title}</h2>

        {/* Arrows */}
        <div className="flex justify-center items-start gap-0 mt-4">
          <div className="flex flex-col items-center">
            <svg width="40" height="80" viewBox="0 0 40 80" fill="none" style={{ color: isDark ? 'rgba(255,255,255,0.3)' : 'black' }}>
              <line x1="20" y1="0" x2="20" y2="65" stroke="currentColor" strokeWidth="2" />
              <polygon points="10,60 20,78 30,60" fill="currentColor" />
            </svg>
          </div>
          <div className="w-[80px]" />
          <div className="flex flex-col items-center">
            <svg width="40" height="80" viewBox="0 0 40 80" fill="none" className="text-[#E6EBF2]">
              <polygon points="10,20 20,2 30,20" fill="currentColor" />
              <line x1="20" y1="15" x2="20" y2="80" stroke="currentColor" strokeWidth="2" />
            </svg>
          </div>
        </div>

        {/* Cards */}
        <div className="flex flex-col lg:flex-row items-center justify-center gap-0 relative">
          {/* Path 1 - Spectateur */}
          <article className={`max-w-md p-9 relative ${isDark ? 'tech-border' : ''}`} style={{ backgroundColor: isDark ? '#07070f' : '#F2F2F2' }}>
            <div className="absolute top-[-14px] right-[-4px] w-[28px] h-[28px] rotate-[135deg] z-40 transition-colors duration-300" style={{ backgroundColor: isDark ? '#000000' : 'white' }} />
            <p className="text-[13px] text-center tracking-wider uppercase transition-colors duration-300" style={{ fontFamily: '"Inter", sans-serif', color: isDark ? 'rgba(255,255,255,0.4)' : 'black' }}>{isFr ? 'RESTER' : 'STAY'}</p>
            <h4 className="text-center text-[36px] lg:text-[48px] font-bold mt-1 transition-colors duration-300" style={{ fontFamily: '"Space Grotesk", sans-serif', color: isDark ? 'rgba(255,255,255,0.6)' : 'black' }}>{t.twoPaths.path1.price}</h4>
            <p className="copy-text text-center mt-4 text-[15px] leading-[1.7] transition-colors duration-300" style={{ fontFamily: '"Inter", sans-serif', color: isDark ? 'rgba(255,255,255,0.4)' : 'black' }} dangerouslySetInnerHTML={{ __html: t.twoPaths.path1.description }} />
            <div className="w-full text-center mt-6">
              <a href="https://www.netflix.com" target="_blank" rel="noopener noreferrer">
                <button className="w-full lg:w-min lg:min-w-[266px] text-xl border-2 p-[1px] group duration-300 transition-all font-bold" style={{ borderColor: isDark ? 'rgba(255,255,255,0.2)' : 'black', backgroundColor: isDark ? '#07070f' : 'white' }}>
                  <div className="py-3.5 px-9 group-hover:bg-transparent duration-300 transition-all m-[1px]" style={{ backgroundColor: isDark ? 'rgba(255,255,255,0.1)' : 'black', color: isDark ? 'rgba(255,255,255,0.5)' : 'white' }}>
                    <span className="text-[19px]">{t.twoPaths.path1.cta}</span>
                  </div>
                </button>
              </a>
            </div>
            <div className="absolute bottom-[-14px] left-[-4px] w-[28px] h-[28px] rotate-[315deg] z-40 transition-colors duration-300" style={{ backgroundColor: isDark ? '#000000' : 'white' }} />
          </article>

          {/* VS */}
          <div className="relative z-30 mx-[-20px] my-4 lg:my-0">
            <div className={`w-[72px] h-[72px] rounded-full border-[3px] flex items-center justify-center transition-all duration-300 ${isDark ? 'tech-glow' : ''}`} style={{ borderColor: isDark ? '#E6EBF2' : tc, backgroundColor: isDark ? '#000000' : 'white' }}>
              <span className="text-[20px] font-bold" style={{ fontFamily: '"Inter", sans-serif', color: isDark ? '#E6EBF2' : tc }}>vs</span>
            </div>
          </div>

          {/* Path 2 - Rejoins */}
          <article className={`max-w-md p-9 relative ${isDark ? '' : 'bg-[#1B2A4A]'}`} style={isDark ? { background: 'linear-gradient(135deg, rgba(0,212,255,0.15) 0%, rgba(0,102,255,0.1) 100%)', border: '1px solid rgba(0,212,255,0.2)' } : {}}>
            <div className="absolute top-[-14px] right-[-4px] w-[28px] h-[28px] rotate-[135deg] z-40 transition-colors duration-300" style={{ backgroundColor: isDark ? '#000000' : 'white' }} />
            <p className="text-[13px] text-white text-center tracking-wider uppercase" style={{ fontFamily: '"Inter", sans-serif', color: isDark ? '#E6EBF2' : undefined }}>{isFr ? 'AVANCER' : 'MOVE'}</p>
            <h4 className="text-white text-center text-[36px] lg:text-[48px] font-bold mt-1" style={{ fontFamily: '"Space Grotesk", sans-serif' }}>{t.twoPaths.path2.price}</h4>
            <p className="copy-text text-center mt-4 text-[15px] leading-[1.7]" style={{ fontFamily: '"Inter", sans-serif', color: 'rgba(255,255,255,0.7)' }} dangerouslySetInnerHTML={{ __html: t.twoPaths.path2.description }} />
            <div className="w-full text-center mt-6">
              <div onClick={() => startCheckout('two_paths_cta')} className="cursor-pointer">
                <button className={`cta-urgent cta-glow-ring w-full lg:w-min lg:min-w-[266px] text-xl border-2 p-[1px] group duration-300 transition-all font-bold ${isDark ? 'tech-glow' : ''}`} style={isDark ? { borderColor: '#E6EBF2', backgroundColor: '#000000' } : { borderColor: '#1B2A4A', backgroundColor: '#F2F5FB' }}>
                  <div className="py-3.5 px-9 group-hover:bg-transparent duration-300 transition-all m-[1px]" style={isDark ? { backgroundColor: '#E6EBF2', color: '#000000' } : { backgroundColor: 'white', color: '#1B2A4A' }}>
                    {t.twoPaths.path2.cta}
                  </div>
                </button>
              </div>
            </div>
            <div className="absolute bottom-[-14px] left-[-4px] w-[28px] h-[28px] rotate-[315deg] z-40 transition-colors duration-300" style={{ backgroundColor: isDark ? '#000000' : 'white' }} />
          </article>
        </div>
      </div>
    </section>
  );
};

export default TwoPathsSection;
